import React from "react";
import { capitalize } from "@helpers/general";

import {
    StyledModal,
    StyledH2,
    StyledLabel,
    CheckboxIcon,
} from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";
import { store } from "../../../../components/VerticalLayout/store";
import storeVatRate from "../store";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useFetchGlobal } from "../../../../api/hooks";
import { associate } from "./useVatRateCount";

type ConfirmationAssociationType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    obj: any;
    handleValidate: Function;
    franchiseData: any;
    setIsSendingTag: Function;
    setCanValidate: Function;
};
export function ConfirmationAssociation({
    isModalOpened,
    setIsModalOpened,
    obj,
    handleValidate,
    franchiseData,
    setIsSendingTag,
    setCanValidate,
}: ConfirmationAssociationType) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { shopID } = useSnapshot(store);
    const { isFormShopUpdatedPays, dataFranchise, dataModified } = useSnapshot(
        storeVatRate
    );

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsModalOpened(!isModalOpened);
                    setCanValidate(false);
                }}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t(
                        "The VAT rate already exists in the franchise. Would you like to associate it with this store?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                        setCanValidate(false);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={async () => {
                        let dataFr: any = dataFranchise.find((x: any) => {
                            return (
                                x.value === franchiseData.value &&
                                x.code === franchiseData.code
                            );
                        });
                        let AncienPays: any = dataFr[t("Country")].ids;

                        setIsModalOpened(!isModalOpened);

                        let object = obj;
                        if (isFormShopUpdatedPays === true) {
                            const dataFr = dataFranchise.find((x: any) => {
                                return (
                                    x.value === franchiseData.value &&
                                    x.code === franchiseData.code
                                );
                            });

                            // Build the object in the required structure
                            const FrObj = {
                                userId: obj.userId,
                                operatorId: obj.operatorId,
                                uuidUser: obj.uuidUser,
                                franchiseId: obj.franchiseId,
                                canReplace: true,
                                data: [
                                    {
                                        id: franchiseData.id,
                                        code: franchiseData.code,
                                        value: franchiseData.value,
                                        tag: dataFr?.tag ?? [],
                                        pays: franchiseData.pays,
                                        status:
                                            dataModified.length === 0
                                                ? true
                                                : false,
                                        archived: false,
                                        isFavorite: true,
                                        shopId: 0,
                                    },
                                ],
                            };

                            const requestOptions = {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(FrObj),
                            };

                            const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/editVatRate`;

                            const data: any = await fetchGlobal(
                                apiUrl,
                                requestOptions
                            );

                            if (data.error) {
                                throw Error("error");
                            }

                            object.updateCountry = true;
                            object.baseCountry = AncienPays;
                        }

                        const transformedObject = {
                            userId: object.userId,
                            operatorId: object.operatorId,
                            uuidUser: object.uuidUser,
                            franchiseId: object.franchiseId,
                            canReplace: true,
                            associations: object.data.map((item: any) => ({
                                shopId: shopID,
                                data: {
                                    id: item.id,
                                    code: item.code,
                                    value: item.value,
                                    tag: item.tag,
                                    pays: item.pays,
                                    status:
                                        dataModified.length === 0
                                            ? true
                                            : false,
                                    archived: item.archived,
                                    isFavorite: item.isFavorite,
                                },
                            })),
                        };

                        await associate(
                            transformedObject,
                            setIsSendingTag,
                            fetchGlobal
                        );

                        toast.success(
                            `${t("The vat rate is successfully associated")!}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                theme: "colored",
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
